import React from "react";
import "./ProjectLoader.css";

export default function ProjectLoader({ progress = null }) {
  const hasProgress = Number.isFinite(progress);
  const percent = hasProgress
    ? Math.max(4, Math.min(100, Math.round(progress * 100)))
    : null;

  return (
    <div className="project-loader" role="status" aria-live="polite">
      <img className="project-loader__logo" src="/logo.PNG" alt="SLV Associates" />
      <div className="project-loader__spinner" aria-hidden="true" />
      <div className="project-loader__label">Preparing your experience</div>
      <div className="project-loader__track" aria-hidden="true">
        <div
          className={`project-loader__bar${hasProgress ? "" : " is-indeterminate"}`}
          style={hasProgress ? { width: `${percent}%` } : undefined}
        />
      </div>
    </div>
  );
}
